// Modal padding
export const PADDING = 18;

// Supported image MIME types for cropping/processing
export const IMAGE_TYPES = ['image/jpg', 'image/jpeg', 'image/png'] as const;

// NOTE: supportedTypes was declared but never used in the codebase - I have exported it here just in case.
// export const SUPPORTED_TYPES = [...IMAGE_TYPES, 'application/pdf', 'text/plain'] as const;

// Unsupported file extensions for drag & drop uploads
export const UNSUPPORTED_TYPES = ['exe', 'msi', 'dll', 'lnk'] as const;

// Blocked extensions for NC file uploads - these file types cannot be used as NC files
export const NC_FILE_BLOCKED_EXTENSIONS = [
  // Images
  'jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp', 'ico', 'tiff', 'heic',
  // Documents
  'pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx',
  // Archives
  'zip', 'rar', '7z', 'tar', 'gz', 'bz2',
  // Executables
  'exe', 'msi', 'dll', 'dmg', 'app', 'pkg', 'deb', 'rpm',
  // Media
  'mp3', 'mp4', 'avi', 'mov', 'wav', 'mkv', 'flv',
] as const;

export const isBlockedNcFileExtension = (extension: string | undefined): boolean => {
  return NC_FILE_BLOCKED_EXTENSIONS.includes(extension?.toLowerCase() as typeof NC_FILE_BLOCKED_EXTENSIONS[number]);
};
